import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';
import { IRegEdUserMap } from './types';

export const REGED_MY_USER_MAP_QUERY_KEY = 'regEdUserMap/me';

export const useRegEdMyUserMapQuery = ({
	enabled = true,
	impersonationContext,
}: {
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryKey: [REGED_MY_USER_MAP_QUERY_KEY, impersonationContext?.account?.id, impersonationContext?.user?.id],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<IRegEdUserMap>({
				path: Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'compliance/regEd/userMap/me',
				}),
				method: 'GET',
				throwOn404: false,
			}),
		meta: {
			toastErrorMessage: 'Failed to load your RegEd user mapping.',
		},
	});
};

export const invalidateRegEdMyUserMap = () => {
	reactQueryClient.invalidateQueries({ queryKey: [REGED_MY_USER_MAP_QUERY_KEY] });
};
